import { Injectable } from '@angular/core';
import type { IInterviewTiming } from '../../shared/models';

@Injectable({ providedIn: 'root' })
export class InterviewTimerService {
  private _timing: IInterviewTiming | null = null;
  private _startedAt: number | null = null;

  public get running(): boolean {
    return null !== this._startedAt;
  }

  public start(timing: IInterviewTiming | null): void {
    this._timing = timing;
    this._startedAt = null !== timing && false === timing.completed ? performance.now() : null;
  }

  public snapshot(): IInterviewTiming | null {
    if (null === this._timing) {
      return null;
    }
    if (null !== this._startedAt) {
      const now: number = performance.now();
      this._timing = {
        ...this._timing,
        elapsedMs: this._timing.elapsedMs + Math.max(0, now - this._startedAt),
        updatedAt: Date.now(),
      };
      this._startedAt = now;
    }
    return { ...this._timing };
  }

  public pause(): boolean {
    if (null === this._startedAt) {
      return false;
    }
    this.snapshot();
    this._startedAt = null;
    return true;
  }

  public finish(): void {
    this.pause();
    if (null === this._timing) {
      return;
    }
    this._timing = { ...this._timing, completed: true, updatedAt: Date.now() };
  }

}
